import React, {useState, useEffect} from "react"
import MenuTab from "./MenuTab"
import headerData from "./headerData"

function Header(props) {
    const [pageId, setPageId] = useState(0)
    
    useEffect(() => {
        setPageId(props.currentPage)
    }, [props.currentPage])

    const menuTabs = headerData.map( tab => {
        return <MenuTab key={tab.id} tabData={tab} callBack={props.changePage} selected={parseInt(tab.id) === pageId ? true : false} />
    })
    
    
    return (
        <header>
            <div className="headTextWrapper" onClick={() => console.log("home screen")}>
                <h1>The Maxwell Mysteries</h1>
            </div>

            {props.loggedIn ? menuTabs : undefined}
        </header>
    )
}

export default Header